<template>
    <div class="assistent-knowledge-form">
        <flex-container>
            <flex-container
                :gap="Size.xs"
            >
                <flex-container justify-content="space-between">
                    <text-heading>Kennis</text-heading>
                    <flex-container
                        size="auto"
                        :gap="Size.xs"
                        align-items="center"
                        align-content="flex-end"
                    >
                        <svg-icon
                            :icon="DatabaseIcon"
                            :size="IconSize.sm"
                            :color="'gray-400'"
                        />
                        <text-decorator :color="'gray-400'" :size="FontSize.xs">
                            KennisID:
                            <template v-if="inDevelopment">
                                <a
                                    :href="`https://platform.openai.com/storage/vector_stores/${assistent.vectorStoreId}`"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {{ assistent.vectorStoreId }}
                                </a>
                            </template>
                            <template v-else>
                                {{ assistent.vectorStoreId }}
                            </template>
                        </text-decorator>
                    </flex-container>
                </flex-container>
                <text-description :color="'gray-800'">
                    Voeg kennis toe om de AI Agent te helpen om sneller en nauwkeuriger vragen te beantwoorden.
                </text-description>
            </flex-container>
            <inline-tabs selected-name="docs">
                <template #labels>
                    <inline-tab-label name="docs">
                        Documenten
                    </inline-tab-label>
                    <inline-tab-label name="web">
                        Website
                    </inline-tab-label>
                    <inline-tab-label name="faq">
                        FAQs
                    </inline-tab-label>
                </template>
                <template #panels>
                    <inline-tab-panel name="docs">
                        <documents-form
                            v-model="assistent"
                        />
                    </inline-tab-panel>
                    <inline-tab-panel name="web">
                        <website-form
                            v-model="assistent"
                        />
                    </inline-tab-panel>
                    <inline-tab-panel name="faq">
                        <faq-form
                            v-model="assistent"
                        />
                    </inline-tab-panel>
                </template>
            </inline-tabs>
        </flex-container>
    </div>
</template>

<script setup lang="ts">
    import {
        FlexContainer,
        FontSize,
        IconSize,
        InlineTabLabel,
        InlineTabPanel,
        InlineTabs,
        Size,
        SvgIcon,
        TextDecorator,
        TextDescription,
        TextHeading,
    } from '@keyvue/one-ui';
    import WebsiteForm from '@/ai/assistent/components/forms/knowledge/WebsiteForm.vue';
    import DatabaseIcon from '@keyvue/one-material-icons/icons/database.svg?component';
    import type { Assistent } from '@keyvue/one-api-client';
    import { computed, type Ref, ref, watch } from 'vue';
    import DocumentsForm from '@/ai/assistent/components/forms/knowledge/DocumentsForm.vue';
    import FaqForm from '@/ai/assistent/components/forms/knowledge/FaqForm.vue';

    const props = defineProps<{ modelValue: Assistent }>();
    const emit = defineEmits<{
        (e: 'update:modelValue', value: Assistent): void;
    }>();

    const assistent = ref(props.modelValue) as Ref<Assistent>;
    const inDevelopment = computed(() => {
        return import.meta.env.MODE === 'development';
    });

    watch(props.modelValue, (value) => {
        if (value !== assistent.value) {
            assistent.value = value;
        }
    });

    watch(assistent, (value: Assistent) => {
        if (value !== props.modelValue) {
            emit('update:modelValue', value);
        }
    }, { deep: true });
</script>

<style scoped lang="scss">
.assistent-knowledge-form {
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    padding-bottom: size(md);
    position: relative;
}
</style>
